module.exports = {
  WE_PARCEL_DPD_EXPRESS: "1^10",
  PARCEL_RETURN_TO_SHOP: "1^22",
  EXPRESS_PAK_SUNDAY_10_30: "1^23",
  WE_DOCUMENT_DPD_EXPRESS: "1^30",
  EU_DPD_EXPRESS: "1^70",
  PARCEL_DPD_CLASSIC: "1^19",
  EXPRESSPAK_DPD_CLASSIC: "1^39",
  BUS_NOTHING_TO_COLLECT: "1^61",
  PALLET_DPD_CLASSIC: "1^79",
  DPD_DIRECT: "1^80",
  ROI_BUS: "1^58",
  HOMECALL: "1^59",
  FREIGHT_PARCEL_DPD_CLASSIC: "1^89",
  GLOBAL_MAIL: "1^93",
  AIR_PARCEL_INTERNATIONAL_AIR: "2^10",
  AIR_DOCUMENT_INTERNATIONAL_AIR: "2^30",
  ROI_BUS_LOCAL: "2^58",
  EU_BY_AIR_INTERNATIONAL_AIR: "2^70",
  DPD_LOCAL_DIRECT: "2^80",
  BUS_NOTHING_TO_COLLECT_LOCAL: "2^61",
  PARCEL_DPD_EUROPE_BY_ROAD: "2^19",
  PARCEL_RETURN_TO_SHOP_LOCAL: "2^22",
};
